const stripe = (state = {}, action) => {
  switch (action.type) {
    default: return state;
  }
};

export default stripe;
